import * as React from "react";
import { useTranslation } from "react-i18next";

const MemberStatTile = ({ value, labelKey, imageName }: any) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center w-full h-16">
      <div className="text-3xl text-blue-700">{value}</div>
      <div className="text-sm font-medium text-gray-400">{t(labelKey)}</div>
    </div>
  );
};

export default MemberStatTile;
